import setReduxAction from 'modules/redux/actions/set'
import addRequestNetworkUtil from 'modules/training/modules/network/utils/add-request'
import { NETWORK_ACTION, NETWORK_PATH } from 'modules/training/modules/network/constants'

function addRequestNetworkAction (params) {
  return (dispatch, getState) => {
    const requests = addRequestNetworkUtil({
      action: params,
      state: getState()
    })
    dispatch(
      setReduxAction({
        type: NETWORK_ACTION.ADD_REQUEST,
        payload: {
          path: NETWORK_PATH.REQUESTS,
          value: requests
        }
      })
    )
  }
}

export default addRequestNetworkAction
